import { IconButton } from "material-ui";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Input from "../../../../../../../components/Input";
import InputSelect from "../../../../../../../components/Input-select";
import { toastError } from "../../../../../../../components/Toast";
import { IconDownload, IconEye, IconLink, IconUpload } from "../../../../../../../icons";
import { listStateOfResponsibility } from "../../constants";
import useEletronicInventoryStore from "../../store/useStore";


export default function RowNine() {
  const { defaultValues, file } = useEletronicInventoryStore();
  const { saveDataOfField, setFile } = useEletronicInventoryStore();

  const handleUploadFile = (e: any) => {
    if (!e?.target?.files[0]) return;
    if (!e?.target?.files[0]?.type.includes("application/pdf")) return toastError("Esse arquivo não é um PDF!");
    setFile(e.target.files[0]);
  };

  return (
    <div className="box-row">
      {defaultValues?.status === "Alocado" && (
        <>
          <InputSelect
            name="statementOfResponsibility"
            label="Termo de Responsabilidade"
            placeholder="Selecionar"
            value={defaultValues?.statementOfResponsibility}
            onChange={(event) => saveDataOfField(event.target)}
            list={listStateOfResponsibility}
          />
          <div className="box-row flex center max-width-none">
            {defaultValues?.statementOfResponsibility == 1 && (
              <>
                <label className="btn bg-primary max-width-none gap margin-10 input-type-file" >
                  <span className="icon-statement-upload">{IconUpload}</span>
                  Upload do Termo
                  <input
                    type="file"
                    onChange={(e) => {
                      handleUploadFile(e);
                    }}
                    accept="application/pdf"
                  />
                </label>
                {file && (
                  <a
                    target="_blank"
                    download={`Termo${defaultValues?.nameProduct && " do" + defaultValues?.nameProduct}`}
                    href={typeof file === 'string' ? file : URL?.createObjectURL(file)}
                    className="btn bg-secondary max-width-none gap margin-10"
                  >
                    <span className="icon-statement-download ">{IconEye}</span>
                    Abrir Termo 
                  </a>
                )}
              </>
            )}
            {defaultValues?.statementOfResponsibility == 2 && (
              <a target="_blank" href="https://app.zapsign.com.br/acesso/entrar" className='teste455 btn bg-secondary'>
                <span className="icon-statement-redirect image-contrast">{IconLink}</span>
                Gerar Termo
              </a>
            )}
          </div>
        </>
      )}
      {defaultValues?.status !== "Em manutenção" && defaultValues?.status !== "Disponível" && defaultValues?.status !== "Alocado" && (
        <Input
          name="observation"
          label="Observação"
          placeholder="Digite uma observação"
          value={defaultValues?.observation}
          setValue={(event) => saveDataOfField(event.target)}
          type="textArea"
        />
      )}
    </div>
  );
}

